import ClassActivityJoinComponent from './class-activity-join.vue';

export const ClassActivityJoinComponentInstall = (Vue) => {
  const Constructor = Vue.extend(ClassActivityJoinComponent)
  Vue.component('class-activity-join', Constructor)
}

import ClassIdCodeJoinComponent from './class-id-code-join'

export const ClassIdCodeJoinComponentInstall  = (Vue) => {
  const Constructor = Vue.extend(ClassIdCodeJoinComponent)
  Vue.component('class-id-code-join', Constructor)
}


